import React, { useState,useEffect } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

export default function LoaderModal({show}){
    
   
    
     

      return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent:'center',}}>
      {show && ( <div className="spinner-overlay">
          <Spinner animation="border" style={{ color: "#842234" }} />
          <p className="mt-3"  style={{marginLeft:"8px", color: "#842234" }}> Loading, please wait...</p>
        </div>)}
        <style jsx="true">{`
        .spinner-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: rgba(0, 0, 0, 0.2); /* Semi-transparent background */
          z-index: 1050; /* Ensure it is above other content */
        }
      `}</style>
    </div>
      );
}